import typeToReducer from "type-to-reducer";

import { SAVE_HLHL_CONTACT_ROLE } from "./types";

const hlhlContactsRoleReducer = typeToReducer(
  {
    [SAVE_HLHL_CONTACT_ROLE]: (state, action) => {
      return {
        ...state,
        hlhl_contact_role: action.hlhl_contact_role,
      };
    },
  },
  {
    hlhl_contact_role: "",
  },
);

export default hlhlContactsRoleReducer;
